import RangeSlider from './RangeSlider'
import '../styles.css'

export default RangeSlider
